import React from 'react';

const Standards: React.FC = () => (
  <>
    <h5 className="spacer">NORMAS</h5>

    <p>
      A Publicidade Legal, ou seja a publicação dos atos legais das empresas de administração pública ou privada, seguem os modelos estabelecidos pela lei, e o Jornal do Comércio disponibiliza espaço no impresso e no online para atender às regras estabelecidas.
    </p>
  </>
);

export default Standards;
